// Initialize cookieconsent when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    if (window.cookieconsent) {
        // Detect language from HTML lang attribute
        const htmlLang = document.documentElement.lang || 'en';
        const isArabic = htmlLang.startsWith('ar');
        const isSpanish = htmlLang.startsWith('es');
        
        // Define content based on language
        const contentMessages = {
            en: {
                message: 'This website uses cookies to improve your browsing experience and analyse site traffic.',
                dismiss: 'Accept',
                allow: 'Accept',
                deny: 'Decline',
                link: false,
                href: false
            },
            ar: {
                message: 'يستخدم هذا الموقع ملفات تعريف الارتباط (الكوكيز) لتحسين تجربة التصفح الخاصة بك وتحليل حركة المرور على الموقع.',
                dismiss: 'قبول',
                allow: 'قبول',
                deny: 'رفض',
                link: false,
                href: false
            },
            es: {
                message: 'Este sitio web utiliza cookies para mejorar tu experiencia de navegación y analizar el tráfico del sitio.',
                dismiss: 'Aceptar',
                allow: 'Aceptar',
                deny: 'Rechazar',
                link: false,
                href: false
            }
        };
        
        let content;
        if (isArabic) {
            content = contentMessages.ar;
        } else if (isSpanish) {
            content = contentMessages.es;
        } else {
            content = contentMessages.en;
        }
        
        window.cookieconsent.initialise({
            type: 'opt-out',
            position: 'bottom',
            theme: 'classic',
            palette: {
                popup: {
                    background: '#000',
                    text: '#fff'
                },
                button: {
                    background: '#fff',
                    text: '#000'
                }
            },
            content: content,
            onInitialise: function(status) {
                // Handle initial status
                if (status === cookieconsent.status.allow) {
                    // Cookies are allowed
                }
            },
            onStatusChange: function(status) {
                // Handle status change
                if (status === cookieconsent.status.allow) {
                    // Cookies are allowed
                }
            }
        });
    }
});

var swiper = new Swiper(".carouselSwiper", {
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '"></span>';
        },
    },
});

// Video play functionality
document.addEventListener('DOMContentLoaded', function() {
    const playButtons = document.querySelectorAll('.play-button');
    
    playButtons.forEach(button => {
        button.addEventListener('click', function() {
            const videoContainer = this.closest('.video-container');
            const iframe = videoContainer.querySelector('iframe');
            const placeholder = videoContainer.querySelector('.video-placeholder');
            
            // Hide placeholder and show iframe
            placeholder.style.display = 'none';
            iframe.style.display = 'block';
            
            // Play the Vimeo video using the Player API
            if (iframe && iframe.contentWindow) {
                iframe.contentWindow.postMessage('{"method":"play"}', '*');
            }
        });
    });

    // Sticky ticker functionality
    const stickyTicker = document.getElementById('sticky-ticker');
    
    if (stickyTicker) {
        let tickerOriginalPosition = null;
        let isSticky = true;
        
        function updateTickerPosition() {
            // Get the original position of the ticker in the document flow
            if (!tickerOriginalPosition) {
                // Temporarily remove fixed positioning to get original position
                const originalClasses = stickyTicker.className;
                const originalStyles = {
                    position: stickyTicker.style.position,
                    bottom: stickyTicker.style.bottom,
                    left: stickyTicker.style.left,
                    right: stickyTicker.style.right
                };
                
                // Remove sticky class temporarily
                stickyTicker.className = stickyTicker.className.replace('ticker-sticky', '');
                stickyTicker.style.position = 'static';
                
                // Get the position
                tickerOriginalPosition = stickyTicker.offsetTop;
                
                // Restore original state
                stickyTicker.className = originalClasses;
                Object.assign(stickyTicker.style, originalStyles);
            }
            
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const windowHeight = window.innerHeight;
            
            // Check if the original position is visible on screen
            // The ticker should become unstuck when its original position becomes visible
            const originalPositionVisible = scrollTop + windowHeight >= tickerOriginalPosition;
            
            if (originalPositionVisible) {
                if (isSticky) {
                    isSticky = false;
                    stickyTicker.classList.add('ticker-unstuck');
                }
            } else {
                if (!isSticky) {
                    isSticky = true;
                    stickyTicker.classList.remove('ticker-unstuck');
                }
            }
        }
        
        // Wait a bit for the page to fully load before initializing
        setTimeout(() => {
            updateTickerPosition();
        }, 100);
        
        // Listen for scroll events
        window.addEventListener('scroll', updateTickerPosition);
        window.addEventListener('resize', function() {
            tickerOriginalPosition = null; // Reset position on resize
            setTimeout(updateTickerPosition, 100);
        });
    }
});